<ng-container [formGroup]="form">
	<div class="header-label">
		<mat-label *ngIf="label" class="mb-1">{{ label }}</mat-label>
		<div class="right" *ngIf="enableHtmlCodeEditor">
			<button
				mat-flat-button
				color="primary"
				class="button size-small wrapper-tiny round-border switch-btn"
				[matTooltip]="interface === 'simple' ? 'Switch to advanced (code) mode' : 'Switch to simple (text) mode'"
				[attr.aria-label]="interface === 'simple' ? 'Switch to advanced (code) mode' : 'Switch to simple (text) mode'"
				type="button"
				(click)="toggleInterface()"
			>
				<mat-icon class="m-0" inline>
					{{ interface === 'simple' ? 'code' : 'text_fields' }}
				</mat-icon>
			</button>
		</div>
	</div>

	<ng-container *ngIf="!codeMode; else monacoEditor">
		<div class="quill-editor-wrapper" #wrapper matAutocompleteOrigin #mergeTagOrigin="matAutocompleteOrigin" [class.with-font-size]="enableFontSizeInput">
			<app-font-size-input
				*ngIf="enableFontSizeInput && quillEditor"
				[quillEditor]="quillEditor"
				(sizeChanged)="onFontSizeChange($event)"
			></app-font-size-input>
			<quill-editor
				#quillEditor
				class="block vysiwyg-quill-editor"
				[class.full-width]="fullWidth"
				[formControlName]="controlName"
				[placeholder]="placeholder"
				[debounceTime]="debounceTime"
				[disabled]="isDisabled"
				[modules]="computedModules"
				[theme]="theme"
				[bounds]="bounds"
				[customToolbarPosition]="'bottom'"
				(onEditorCreated)="onEditorCreated($event)"
			></quill-editor>
			<app-writing-tools
				*ngIf="showWritingTools"
				[value]="form.get(controlName)?.value"
				(valueChanged)="onWritingToolsChange($event)"
			></app-writing-tools>
		</div>

		<ng-container *ngIf="enableMergeTags">
			<input #hiddenInput matInput class="hidden-input" [formControl]="autocompleteCtrl" [matAutocomplete]="auto" [matAutocompleteConnectedTo]="mergeTagOrigin"/>

			<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectAutosuggest($event)">
				<mat-option *ngFor="let tag of filteredTags$ | async" [value]="tag">
					{{ tag?.[optionLabelKey] || tag?.[optionValueKey] || tag?.id }}
				</mat-option>
			</mat-autocomplete>
		</ng-container>

		<div *ngIf="hint" class="input-hint">{{ hint }}</div>
	</ng-container>
	<ng-template #monacoEditor>
		<app-monaco-input
			#variablesInput
			[hideLabel]="true"
			[label]="label"
			class="block full-width mt-3 mb-1"
			[currentValue]="form.get(controlName)?.value"
			[fullWidth]="true"
			[debounceTime]="debounceTime"
			[language]="'html'"
			[showFormatButton]="true"
			[showValidationError]="true"
			(valueChange)="onMonacoChange($event)"
		>
		</app-monaco-input>
	</ng-template>
</ng-container>
